// ==========================================================================
// hainault-calendar.js, powered by groots
// Author: Globalia
// Licensed under the WTFPL license
// ==========================================================================


// groots core !! DO NOT DELETE !!
// --------------------------------------------------------------------------

// Declaration of groots namespace
window.groots = window.groots || {};

// Display debug informations
window.groots.verbose = false;

// Require groots JS-Plugins
window.groots.require = {
    grInlineSVG:            'auto',
    grObjectfitEmulator:    false,
    grEqualizer:            false,
    grLazyLoader:           'auto',
    grNavigation:           true,
    grFormSelect:           false, //todo
    grFormUpload:           'auto',
    grFormNormalize:        false, //todo
    grFormValidation:       false, //todo
    grAccTabs:              false,
    grVideoYoutube:         false,
    grGoogleMap:            false,
    grDropdown:             'auto'
};

// Let the magic happens
require('../../garden/_groots.js');

// --------------------------------------------------------------------------

// Plugins
require('selectize');
require('mark.js/dist/jquery.mark.js');
require('bootstrap-datepicker'),
require('bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js'),
require('timepicker');
require('fullcalendar');
require('fullcalendar/dist/locale/fr-ca.js');
require('datatables.net');
require('easy-autocomplete');

require('./plugins/_jquery.form.js');

require('mustache');

// Components
require('./_helpers.js');
require('./_datahref.js');
require('./_inputnav.js');
require('./_selectize.js');
require('./_grInputNumber.js');
require('./_progress-bar.js');
require('./_tabs.js');
require('./_tooltip-simple.js');
require('./_expander.js');
require('./_datepicker.js');
require('./_timepicker.js');
require('./_notification.js');
require('./_places-autocomplete.js');
require('./_bookingcalendar.js');
require('./_previewcalendar.js');
require('./_edittitle.js');
require('./_countries.js');
require('./_search.js');
require('./_header.js');
require('./_formconfirm.js');
require('./_formdeleteconfirm.js');
require('./_bookingdate.js');
require('./_bookingfreeartist.js');
require('./_booking.js');
require('./_bookingprocess.js');
require('./_bookingrepresentationrelease.js');
require('./_ticketfee.js');
require('./_bookingartist.js');
require('./_artistfee.js');
require('./_bookingpayment.js');
require('./_deposit.js');
require('./_bookingcontact.js');
require('./_activity.js');
require('./_reminders.js');
require('./_ticketsalesregister.js');
require('./_ticketsalesformalregister.js');
require('./_quicksearch.js');
require('./_ajax.js');
require('./_parsley.js');
require('./_forms.js');
require('./_table.js');
require('./_search-result.js');
require('./_roadmap.js');
require('./_remindalerts.js');
require('./_apiactions.js');
require('./_synchronizeInputs.js');
require('./_formexpander.js');
require('./_tax.js');
require('./_regioncode.js');
require('./_spreadsheet.js');
require('./_contacttooltip.js');
require('./_touragentpayment.js');
require('./_userpersonpermissionset.js');
require('./_app.js');

$('body').app();
